var {AmpersandState} = require('catalog/libs');

/**
 * Product List Pagination State Base Model
 * pagination + utilitybar modules inherit from this
 */
module.exports = AmpersandState.extend({

    /**
     * state properties
     */
    props: {
        'hitsPerPage': 'number',
        'totalMatches': 'number',
        'startIndex': 'number',
        'numberOfPages': 'number',
        'previousPage': 'number',
        'currentPage': 'number',
        'nextPage': 'number'
    }
});
